import { gql } from 'apollo-angular';
import { Task } from 'src/app/rent-module/shared/entities/task/task';

export const COMPLETE_TASK_QUERY = gql`
query getTask(
  $id: UUID
)
{
  task: getTask(
    id: $id
  ){
    ... taskExcerpt
  }
}

fragment taskExcerpt on Task{
  id
  type
  completedDateTime
  timeEntriesSum
  timeEntries {
    id
    taskId
    user{
      id
      firstName
      lastName
    }
    startDateTime
    endDateTime
    duration
    pauseDuration
    note
    category{
      name
      id
    }
  }
  completedBy{
    firstName
    lastName
  }
  dueDateTimePeriod {
    modifier
    dateTime
    fromDateTime
    toDateTime
    precision
  }
  state
  title
  description
  color
  formControlTemplate
  context
  order{
    id
    number
    type
    customer {
      id
      type
      companyName
      companyNameExtension
      firstName
      lastName
    }
    location {
      name
    }
  }
  address {
    id
    country
    city
    postalCode
    street
    houseNumber
    name
    lat
    lng
    text
    type
    note
    geocodingResultGrade
  }
  linkedResources: linkedEntities(entityType: "Resource") {
    linkType
    entity {
      ... on Resource {
          id
          name
          number
          text
      }
    }
  }
  linkedContacts: linkedEntities(entityType: "Contact") {
    linkType
    entity {
      ... on Contact {
          id
          type
          number
          companyName
          companyNameExtension
          firstName
          lastName
      }
    }
  }
  assignment {
    assigneeId
    assignmentType
    typeLabel
    name
  }
}
`;

export interface CompleteTaskQuery {
  task: Task;
}

export const COMPLETE_TASK_MUTATION = gql`
mutation completeTask($taskId: UUID, $formModelInput: FormModelInput) {
  completeTask(
    taskId: $taskId,
    formModelInput: $formModelInput)
  {
      id
  }
}
`;

